export enum BID_STATUS_DISPLAY {
  ASSIGNMENT = "New",
  SETUP = "Setup",
  PRICING = "Pricing",
  APPROVED = "Completed",
}
